export default {"src":"/_next/static/media/TENX.cc8ad55a.svg","height":18,"width":18};